import React from 'react';
import { sendAnswers, usePayment } from '../../store/PaymentContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCommon } from '../../store/CommonContext';
import { useTemplate } from '../../store/TemplateContext';
import { sendLinksAnswers, useLinks } from '../../store/LinksContext';

import './Link.css';

interface Props {
  href: string;
  additionalClasses?: string;
  onClick?: () => void;
  attributes?: { [key: string]: string };
  dataid?: string | null;
  children?: string | React.ReactNode;
}

const Link: React.FC<Props> = (props: Props) => {
  // const { configuration } = useContext(CommonContext);
  const { href, additionalClasses = '', attributes = [], dataid, children } = props;

  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get('id');

  const {
    state: { configuration },
    dispatch: commonDispatch,
  } = useCommon();
  const { dispatch: templateDispatch } = useTemplate();
  const { dispatch: paymentDispatch } = usePayment();
  const { dispatch: linksDispatch } = useLinks();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.stopPropagation();

    if (dataid) {
      e.preventDefault();

      if (location.pathname.includes('links')) {
        sendLinksAnswers({
          answers: { answers: { [dataid]: true, id } },
          dispatch: linksDispatch,
          navigate,
        });
      } else {
        sendAnswers({
          answers: { [dataid]: true },
          dispatch: paymentDispatch,
          navigate,
          location,
          configuration,
          commonDispatch,
          templateDispatch,
        });
      }
    }
  };

  if (!href && !dataid) {
    return null;
  }

  if (!href && dataid) {
    console.log('href---2', href);
    return (
      <span
        className={`${additionalClasses} ui-widget-link`}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        dataid={dataid}
        onClick={handleClick}
        {...attributes}
      >
        {children}
      </span>
    );
  }

  return (
    <a
      className={`${additionalClasses} ui-widget-link`}
      href={href}
      target="_blank"
      // style={{ color: (configuration?.PrimaryColor as string) || PRIMARY_COLOR }}
      rel="noreferrer"
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      dataid={dataid}
      onClick={handleClick}
      {...attributes}
    >
      {children}
    </a>
  );
};

export default Link;
